<template>
  <div>
    <link href="https://fonts.googleapis.com/css2?family=Gilroy&display=swap" rel="stylesheet">

    <div class="action-buttons mb-3" v-if="!isLoading">
      <va-popover
        placement="top"
        :message="'Download PDF'">
        <va-button large icon="fa fa-download" color="#29C4AA"></va-button>
      </va-popover>
      <va-popover
        placement="top"
        :message="'Print'">
        <va-button large icon="fa fa-print" color="#29C4AA" @click.prevent="printReport"></va-button>
      </va-popover>

    </div>
    <div v-if="isLoading">
      <LoadingPlaceholder></LoadingPlaceholder>
    </div>
    <div v-else>
      <Header id="report-header"
              :patientName="data.patientDetails.patientName"
              :date="data.patientDetails.date"
      />
      <div class="report-container" id="report-container">
        <div class="report-page">
          <!-- Report content -->
          <div class="report-content">
            <PatientDetails
              :data="data.patientDetails"/>
            <PatientOverallSummary
              :data="data.overallSummary"/>
            <div>
              <div style="height: 100px" v-if="showSection('bio_param')">
                <ReportPageBreaker
                  :slug="'biometric_parameters'"
                  :description="data.resultsByGroupClassification.find(elem => elem.groupClassificationSlug.toLowerCase() === 'bio_param').description"
                  :primaryColor="'#6D98F4'"
                  :secondaryColor="'#D9E4FC'"
                  :descriptionTextColor="'#b8c7ea'"
                />
              </div>
              <BloodPressureMeasurements class="mt-3" v-if="showGroup('MeasurementGroup_nameBloodPressure')" :data="data.resultsByGroupClassification.find(elem => elem.groupClassificationSlug.toLowerCase() === 'bio_param').groupResults.find(elem => elem.groupName === 'MeasurementGroup_nameBloodPressure')"/>
            </div>

          </div>
          <!--<div style="height: 100px">
            <Footer/>
          </div>-->
        </div>

        <div class="report-page" v-if="showSection('bio_param')">
          <!--<Header :patientName="'Pedro Miguel Prates Alves'" :date="'29/12/2023'"/>-->
          <!-- Report content -->
          <div class="report-content">
            <TemperatureMeasurements class="mt-3" v-if="showGroup('MeasurementGroup_nameTemperature')" :data="data.resultsByGroupClassification.find(elem => elem.groupClassificationSlug.toLowerCase() === 'bio_param').groupResults.find(elem => elem.groupName === 'MeasurementGroup_nameTemperature')"/>
            <GlicemiaMeasurements class="mt-4" v-if="showGroup('MeasurementGroup_nameGlucose')" :data="data.resultsByGroupClassification.find(elem => elem.groupClassificationSlug.toLowerCase() === 'bio_param').groupResults.find(elem => elem.groupName === 'MeasurementGroup_nameGlucose')"/>
          </div>
          <!--<div style="height: 100px">
            <Footer/>
          </div>-->
        </div>

        <div class="report-page" v-if="showSection('bio_param')">
          <!--<Header :patientName="'Pedro Miguel Prates Alves'" :date="'29/12/2023'"/>-->
          <!-- Report content -->
          <div class="report-content">
            <OximetryMeasurements class="mt-3" v-if="showGroup('MeasurementGroup_nameOximetryBeurer')" :data="data.resultsByGroupClassification.find(elem => elem.groupClassificationSlug.toLowerCase() === 'bio_param').groupResults.find(elem => elem.groupName === 'MeasurementGroup_nameOximetryBeurer')"/>
            <SpirometryMeasurements class="mt-4" v-if="showGroup('MeasurementGroup_nameSpirometry')" :data="data.resultsByGroupClassification.find(elem => elem.groupClassificationSlug.toLowerCase() === 'bio_param').groupResults.find(elem => elem.groupName === 'MeasurementGroup_nameSpirometry')"/>
          </div>
          <!--<div style="height: 100px">
            <Footer/>
          </div>-->
        </div>

        <div class="report-page" v-if="showSection('bio_param')">
          <!-- <Header :patientName="'Pedro Miguel Prates Alves'" :date="'29/12/2023'"/> -->
          <!-- Report content -->
          <div class="report-content">
            <BodyCompositionsMeasurements class="mt-3" v-if="showGroup('MeasurementGroup_nameAdvancedWeight')" :data="data.resultsByGroupClassification.find(elem => elem.groupClassificationSlug.toLowerCase() === 'bio_param').groupResults.find(elem => elem.groupName === 'MeasurementGroup_nameAdvancedWeight')"/>
          </div>
          <!--<div style="height: 100px">
            <Footer/>
          </div>-->
        </div>

        <div class="report-page">
          <!--<Header :patientName="'Pedro Miguel Prates Alves'" :date="'29/12/2023'"/>-->
          <!-- Report content -->
          <div class="report-content">
            <div v-if="showSection('geriatrics')">
              <div style="height: 100px">
                <ReportPageBreaker
                  :slug="'geriatrics'"
                  :description="data.resultsByGroupClassification.find(elem => elem.groupClassificationSlug.toLowerCase() === 'geriatrics').description"
                  :primaryColor="'#8F76DB'"
                  :secondaryColor="'#EDE9FA'"
                  :descriptionTextColor="'#c7bcea'"
                />
              </div>
              <FrailtyMeasurements class="mt-3" v-if="showGroup('MeasurementGroup_name_Frail_Elderly_Assessment')" :data="data.resultsByGroupClassification.find(elem => elem.groupClassificationSlug.toLowerCase() === 'geriatrics').groupResults.find(elem => elem.groupName === 'MeasurementGroup_name_Frail_Elderly_Assessment')"/>
              <SarcopeniaMeasurements class="mt-4" v-if="showGroup('MeasurementGroup_name_Sarcopenia')" :data="data.resultsByGroupClassification.find(elem => elem.groupClassificationSlug.toLowerCase() === 'geriatrics').groupResults.find(elem => elem.groupName === 'MeasurementGroup_name_Sarcopenia')"/>
            </div>
          </div>
          <!--<div style="height: 100px">
            <Footer/>
          </div>-->
        </div>


        <div class="report-page">
          <!--<Header :patientName="'Pedro Miguel Prates Alves'" :date="'29/12/2023'"/>-->
          <!-- Report content -->
          <div class="report-content">
            <div v-if="showSection('audiology')">
              <div style="height: 100px" >
                <ReportPageBreaker
                  :slug="'audiology_parameters'"
                  :description="data.resultsByGroupClassification.find(elem => elem.groupClassificationSlug.toLowerCase() === 'audiology').description"
                  :primaryColor="'#FFA564'"
                  :secondaryColor="'#FFF3EB'"
                  :descriptionTextColor="'#fbe5d1'"
                />
              </div>
              <AudiologyMeasurements class="mt-3"/>
            </div>

            <div v-if="showSection('optometry')">
              <div style="height: 100px" >
                <ReportPageBreaker
                  :slug="'optometry'"
                  :description="data.resultsByGroupClassification.find(elem => elem.groupClassificationSlug.toLowerCase() === 'optometry').description"
                  :primaryColor="'#F9679E'"
                  :secondaryColor="'#FADEEA'"
                  :descriptionTextColor="'#fbcce1'"
                />
              </div>
              <OptometryMeasurements class="mt-3" v-if="showGroup('MeasurementGroup_nameOptometry')" :data="data.resultsByGroupClassification.find(elem => elem.groupClassificationSlug.toLowerCase() === 'optometry').groupResults.find(elem => elem.groupName === 'MeasurementGroup_nameOptometry')"/>
            </div>

          </div>
          <!--<div style="height: 100px">
            <Footer/>
          </div>-->
        </div>

        <div class="report-page p-0">
          <div class="reference-and-historical-table-header ">
            <h5 class="mb-0 measurement-title">— {{$t('checkup_plus.reports.reference_values.title')}}</h5>
          </div>
          <div v-for="elem in data.overallReferenceValues">
            <DataTable
              :type="'referenceValues'"
              :title="elem.referenceTable"
              :columns="elem.referenceTableHeaders"
              :data="elem.tableRows"
            />
          </div>

        </div>

        <div class="report-page p-0">
          <div class="reference-and-historical-table-header ">
            <h5 class="mb-0 measurement-title">— {{$t('checkup_plus.reports.historical_data.title')}}</h5>
            <label class="mb-0 card-description text-uppercase"> {{ $t('checkup_plus.reports.historical_data.last_10_measurements_data') }} </label>
          </div>
          <div v-for="elem in data.historicalData">
            <DataTable
              :type="'historic'"
              :title="elem.groupName"
              :columns="elem.headers"
              :data="elem.historyData"
            />
          </div>

        </div>
      </div>
      <div style="height: 100px" id="report-footer">
        <Footer id="report-footer"/>
      </div>
    </div>

    <canvas ref="canvas"></canvas>


  </div>

</template>

<script>
import html2pdf from 'html2pdf.js';
import jspdf from 'jspdf';

import Footer from "@/components/checkup_plus/patients/Report/Footer.vue";
import Header from "@/components/checkup_plus/patients/Report/Header.vue";
import PatientDetails from "@/components/checkup_plus/patients/Report/Contents/PatientDetails.vue";
import PatientOverallSummary from "@/components/checkup_plus/patients/Report/Contents/PatientOverallSummary.vue";
import ReportPageBreaker from "@/components/checkup_plus/patients/Report/Contents/ReportPageBreaker.vue";
import BloodPressureMeasurements
  from "@/components/checkup_plus/patients/Report/Contents/MeasurementsParameters/BloodPressureMeasurements.vue";
import TemperatureMeasurements
  from "@/components/checkup_plus/patients/Report/Contents/MeasurementsParameters/TemperatureMeasurements.vue";
import GlicemiaMeasurements
  from "@/components/checkup_plus/patients/Report/Contents/MeasurementsParameters/GlicemiaMeasurements.vue";
import OximetryMeasurements
  from "@/components/checkup_plus/patients/Report/Contents/MeasurementsParameters/OximetryMeasurements.vue";
import SpirometryMeasurements
  from "@/components/checkup_plus/patients/Report/Contents/MeasurementsParameters/SpirometryMeasurements.vue";
import BodyCompositionsMeasurements
  from "@/components/checkup_plus/patients/Report/Contents/MeasurementsParameters/BodyCompositionsMeasurements.vue";
import FrailtyMeasurements
  from "@/components/checkup_plus/patients/Report/Contents/MeasurementsParameters/FrailtyMeasurements.vue";
import SarcopeniaMeasurements
  from "@/components/checkup_plus/patients/Report/Contents/MeasurementsParameters/SarcopeniaMeasurements.vue";
import AudiologyMeasurements
  from "@/components/checkup_plus/patients/Report/Contents/MeasurementsParameters/AudiologyMeasurements.vue";
import OptometryMeasurements
  from "@/components/checkup_plus/patients/Report/Contents/MeasurementsParameters/OptometryMeasurements.vue";
import DataTable from "@/components/checkup_plus/patients/Report/Contents/DataTable.vue";
import html2canvas from "html2canvas";
import { OneCareService } from '@/api/OneCareService';
import LoadingPlaceholder from '@/components/common/LoadingPlaceholder.vue';
import moment from 'moment';

export default {
  components: {
    LoadingPlaceholder,
    DataTable,
    OptometryMeasurements,
    AudiologyMeasurements,
    SarcopeniaMeasurements,
    FrailtyMeasurements,
    BodyCompositionsMeasurements,
    SpirometryMeasurements,
    OximetryMeasurements,
    GlicemiaMeasurements,
    TemperatureMeasurements, BloodPressureMeasurements, ReportPageBreaker, PatientOverallSummary, PatientDetails, Header, Footer},
  data() {
    return {
      isLoading: true,
      data: {
        patientDetails: {
          patientName: null,
          date: null,
        },
        overallSummary: {
          recommendation: null,
          results: {

          }
        },
        overallReferenceValues: [],
        historicalData: [],
        measurementGroupsToShow: [],
      }
    }
  },
  mounted() {
    const patientId = this.$router.currentRoute.params.id
    this.getReportData(patientId)
  },
  /*beforeRouteEnter (to, from, next) {
    if (to.params.id !== undefined) {
      next(vm => {
        vm.getReportData(parseInt(to.params.id))
        vm.from = from
      })
    } else {
      next(from)
    }
  },
  beforeRouteUpdate (to, from, next) {
    if (to.params.id !== undefined) {
      this.getReportData(parseInt(to.params.id))
    } else {
      next(from)
    }
  },*/
  methods: {
    async getReportData(patientId) {
      try {
        let data = await OneCareService.getReportData(patientId)
        this.data.patientDetails = {...this.data.patientDetails,
          patientName: data.headerInformation.patientName,
          date: moment.utc(data.headerInformation.appointmentDate).local().format('DD/MM/YYYY'),
          gender: data.headerInformation.sex,
          nationality: data.headerInformation.nationality,
          birthdate: moment(data.headerInformation.dateOfBirth).format('DD/MM/YYYY'),
          address: data.headerInformation.patientAddress,
          facility: data.headerInformation.facilityName,
          facilityId: data.headerInformation.facilityId,
          entity: data.headerInformation.entityName,
          entityId: data.headerInformation.entityId
        }
        this.data.overallSummary = {
          ...this.data.overallSummary,
          recommendation: data.overallSummary.recommendation,
          results: []
        }
        data.overallSummary.overallSummaryResults.forEach(elem => {
          this.data.overallSummary.results.push({
            slug: elem.classificationSlug,
            currentNormal: elem.currentNormal,
            currentNotNormal: elem.currentNotNormal,
            previousNormal: elem.previousNormal,
            previousNotNormal: elem.previousNotNormal,
            totalParameters: elem.totalParameters
          })
        })
        this.data.resultsByGroupClassification = data.resultsByGroupClassification
        this.data.overallReferenceValues = data.overallReferenceValues
        this.data.overallReferenceValues.forEach(elem => {
          elem.referenceTable = this.$t(`dashboard_new_evollu.parameters.graphs.titles.${elem.referenceTable.toLowerCase()}`)
        })

        this.data.historicalData = data.historicalData
        //Parse audiology historical data because some info is not necessary
        this.data.historicalData.forEach(elem => {
          if(elem.groupName === 'Audiologia') {
            elem.headers[1] = this.$t('clinical.appointments.hearing_devices.left_abreviatture') + ' 1000 Hz'
            elem.headers[2] = this.$t('clinical.appointments.hearing_devices.left_abreviatture') + ' 2000 Hz'
            elem.headers[3] = this.$t('clinical.appointments.hearing_devices.left_abreviatture') + ' 4000 Hz'
            elem.headers[4] = this.$t('clinical.appointments.hearing_devices.left_abreviatture') + ' 6000 Hz'
            elem.headers[5] = this.$t('clinical.appointments.hearing_devices.right_abreviatture') + ' 1000 Hz'
            elem.headers[6] = this.$t('clinical.appointments.hearing_devices.right_abreviatture') + ' 2000 Hz'
            elem.headers[7] = this.$t('clinical.appointments.hearing_devices.right_abreviatture') + ' 4000 Hz'
            elem.headers[8] = this.$t('clinical.appointments.hearing_devices.right_abreviatture') + ' 6000 Hz'
            elem.headers.splice(9, 2)
            elem.headers.splice(10, 2)
            elem.headers.splice(11, 2)
            elem.headers.splice(11, 6)

            elem.historyData.forEach(data => {
              data.data.splice(9, 2)
              data.data.splice(10, 2)
              data.data.splice(11, 2)
              data.data.splice(11, 6)
            })
          }
        })
        //console.log(this.data.historicalData)

        const groupedGroupResults = this.data.resultsByGroupClassification.flatMap(elem => elem.groupResults)
        this.measurementGroupsToShow = groupedGroupResults.map(elem => elem.groupName)
        //console.log(this.measurementGroupsToShow)

        this.isLoading = false
        this.parseDataForJsReport(this.data)

      } catch (err) {
        console.log(err)
      }

    },
    parseDataForJsReport(data) {
      let finalData = {}
      const colours= {
        "BIO_PARAM": {
          primaryColor: "#6D98F4",
          secondaryColor: "#D9E4FC",
          descriptionTextColor: "#b8c7ea",
        },
        "GERIATRICS": {
          primaryColor:"#8F76DB",
          secondaryColor:"#EDE9FA",
          descriptionTextColor:"#c7bcea"
        },
        "AUDIOLOGY": {
          primaryColor:"#FFA564",
          secondaryColor:"#FFF3EB",
          descriptionTextColor:"#fbe5d1"
        },
        "OPTOMETRY": {
          primaryColor:"#F9679E",
          secondaryColor:"#FADEEA",
          descriptionTextColor:"#fbcce1"
        },
        "COMPLEX_MONITORING": {
          primaryColor:"#8F76DB",
          secondaryColor:"#EDE9FA",
          descriptionTextColor:"#c7bcea"
        }
      }
      finalData.data = {...data}
      finalData.data.resultsByGroupClassification.forEach(elem => {
        if(!Object.keys(colours).includes(elem.groupClassificationSlug)) {
          elem.primaryColor = "#6D98F4"
          elem.secondaryColor = "#D9E4FC"
          elem.descriptionTextColor = "#b8c7ea"
        } else {
          elem.primaryColor = colours[elem.groupClassificationSlug].primaryColor
          elem.secondaryColor = colours[elem.groupClassificationSlug].secondaryColor
          elem.descriptionTextColor = colours[elem.groupClassificationSlug].descriptionTextColor
        }
        elem.groupResults.forEach(elem => {
          if(elem.lastMeasurementTimestamp) {
            elem.lastMeasurementStrDate = moment(elem.lastMeasurementTimestamp).format('DD/MM/YYYY HH:mm')
          } else {
            elem.lastMeasurementStrDate = ""
          }

          let parsedReferenceValues = []
          elem.results.forEach(result => {
            result.referenceValues.forEach(refValue => {
              var str = ""
              let index = 0
              let criteriasLength = refValue.criteriaList.length
              if(refValue.operator === "AND") {
                refValue.criteriaList.forEach(elem => {
                  str+= `${elem.attributeName} ${elem.criteria} `
                  ++index
                  if (index < criteriasLength) {
                    str += "& "
                  }
                })
              }
              parsedReferenceValues.push({
                criteria: str,
                resultMatchingCriteria: refValue.resultMatchingCriteria
              })
            })
            result.parsedReferenceValues = parsedReferenceValues
          })

        })
      })

      finalData.data.patientDetails.consultationDate = finalData.data.patientDetails.date


      finalData.template = {
        name: "checkup-main"
      }
      finalData.options = {
        localization: {
          language: "pt"
        }
      }
      console.log(data)
      console.log(finalData)
    },
    showSection(section) {
      const elem = this.data.resultsByGroupClassification.find(elem => elem.groupClassificationSlug.toLowerCase() === section)
      return elem && elem.groupResults.length > 0
    },
    showGroup(groupName) {
      return this.measurementGroupsToShow.includes(groupName)
    },
    async printReport() {

      const reportContainer = document.getElementById('report-container');
      const headerElement = document.getElementById('report-header');
      const footerElement = document.getElementById('report-footer');

      var opt = {
        margin: [20, 0, 20, 0],
        filename: 'report.pdf',
        image: {type: 'jpeg', quality: 0.98},
        html2canvas: {scale: 1},
        jsPDF: {unit: 'mm', format: "a4", orientation: 'portrait'},
        pagebreak: {mode: ['avoid-all', 'css', 'legacy']},
        autoPageBreak: true,
      };

      html2canvas(headerElement).then((headerImg) => {
        html2canvas(footerElement).then((footerImg) => {
          html2pdf().set(opt).from(reportContainer).toPdf().get('pdf')
            .then(async (pdf) => {
              var totalPages = pdf.internal.getNumberOfPages();
              var pageHeight = pdf.internal.pageSize.height || pdf.internal.pageSize.getHeight();
              var pageWidth = pdf.internal.pageSize.width || pdf.internal.pageSize.getWidth();
              var footerText = '';
              var i;
              for (i = 0; i <= totalPages; i++) {
                pdf.setPage(i);
                pdf.addImage(headerImg.toDataURL('image/jpeg'), 'JPEG',0,0,205,20);
                pdf.addImage(footerImg.toDataURL('image/jpeg'), 'JPEG',0,pageHeight-21,210,21);
                if (i > 1) {
                  pdf.setFontSize(8);
                  pdf.setTextColor("#FFFFFF");
                  pdf.text('P. ' + i + '/' + totalPages + '\n' + footerText, pageWidth - 8,
                    pageHeight - 3, {align: 'right'});
                }
              }
            }).save()
        })
      })

    },

  }
}

</script>

<style>
.card-title {
  color: #23292E;
  font-weight: bold;
  font-size: 15px;
}

.card-description {
  color: #b3b3b3;
  font-weight: lighter;
  font-size: 13px;
}

.card-text-bold {
  color: #23292E;
  font-weight: bold;
  font-size: 14px;
}

.card-text-normal {
  color: #494b4d;
  font-size: 13px;
}

.measurement-title {
  color: #23292E;
  font-weight: bold;
  font-size: 20px;
}

.measurement-timestamp {
  color: #b3b3b3;
  font-weight: lighter;
  font-size: 12px;
}

.measurement-result-good {
  color: #7dca52;
}

.measurement-result-bad {
  color: #e65555;
}

.measurement-result-na {
  color: #6D98F4;
}

.measurement-card {
  .title-container {
    .card-title {
      padding-top: 10px;
    }
  }
}

</style>

<style scoped lang="scss">
  .report-container {
    font-family: "Gilroy", sans-serif;
    background: white !important;
    //width: 210mm;
    //width: 1240px;
  }
  .report-page {
    //width: 1240px;
    //height: 1654px;
    // width: 210mm;
    //height: 297mm;
    //box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    padding: 20px;
    position: relative;
  }

  .report-content {
    //margin-left: -20px !important;
  }

  .reference-and-historical-table-header {
    height: 80px;
    width: 100%;
    background-color: #e8e8e8;
    padding-right: 0 !important;
    display: flex;
    align-items: start;
    padding-left: 20px;
    margin-bottom: 20px;
    flex-direction: column;
    justify-content: center;
  }



  .Header {
    position: fixed; /* Ensure the header stays fixed at the top */
    top: 0; /* Position the header at the top */
    width: 100%; /* Ensure the header spans the entire width */
    z-index: 999; /* Ensure the header is on top of other content */
    /* Add any other styles for your header component */
  }

  /* Add styles to repeat header every 1122px */
  .Header:after {
    content: ''; /* Add an empty content */
    display: block; /* Display as a block element */
    position: absolute; /* Position absolutely */
    top: 100px;
    left: 0; /* Position at the left */
    right: 0; /* Position at the right */
    height: 1122px; /* Set the height of the repeated header */
    background-color: transparent; /* Set the background color of the repeated header */
  }

</style>
